import React, { memo } from 'react';

import barnOwlClient, { ConvertBarnOwlAccountDto } from 'clients/barnOwl';
import BackOfficeBarnOwlFormDrawer from 'components/drawers/BackOfficeBarnOwlFormDrawer';
import BarnOwlConvertFormItems from 'components/forms/BarnOwlConvertFormItems';
import { SEARCH_PARAMS } from 'constants/search-params';

type BarnOwlConvertFormValues = ConvertBarnOwlAccountDto & {
  enterpriseId: number;
};

function BackOfficeBarnOwlConvertDrawer(): JSX.Element {
  return (
    <BackOfficeBarnOwlFormDrawer<BarnOwlConvertFormValues>
      drawerValue={SEARCH_PARAMS.DRAWER.values.CONVERT_BARN_OWL_ACCOUNT}
      title="Convert Barn Owl account"
      footerLabel="Convert and import cameras"
      submit={async ({ enterpriseId, accountId, siteId }) => {
        const response = await barnOwlClient.convertBarnOwlAccount(Number(enterpriseId), {
          accountId,
          siteId
        });
        if (response.error) {
          return { error: response.error.message || 'Unable to convert Barn Owl account' };
        }
        return {
          successMessage: `Converted Barn Owl account ${response.data?.email ?? accountId}`
        };
      }}
    >
      <BarnOwlConvertFormItems />
    </BackOfficeBarnOwlFormDrawer>
  );
}

export default memo(BackOfficeBarnOwlConvertDrawer);
